<template>
    <div class="wrap">
        <div class="container">
            <div class="addbook">
                <h3 class="personal_titile">我的地址</h3>
                <router-link class="ress_tz" :to="{path:'editaddress',query:{id:value.id}}" v-for="(value,index) in address_list" :key="index">
                    <van-row class="pay_reasss booklist bordernone" type="flex" align="center" justify="space-between">
                        <van-col>
                            <van-icon name="location-o" />
                        </van-col>
                        <van-col style="flex: 1;">
                            <div class="name"><span>{{value.name}}</span>T:{{value.tel}}</div>
                            <div>{{value.address}} {{value.address_line2}} {{value.city_name}} {{value.province_name}}
                                {{value.email}}</div>
                        </van-col>
                        <van-col>
                            <van-icon name="arrow" />
                        </van-col>
                    </van-row>
                </router-link>
            </div>
            <van-row type="flex" align="center" justify="center">
                <van-col span="20">
                    <router-link to="/addaddress">
                        <van-button block type="primary">添加新地址</van-button>
                    </router-link>
                </van-col>
            </van-row>
        </div>
        <v-foot></v-foot>
    </div>
</template>
<style>

</style>
<script>
    export default {
        components: {},
        created() {
            this.getData();
            this.getUserInfo(true);
            localStorage.setItem('address_return_path','/address')
            this.getjiant()
        },
        data() {
            return {
                address_list: {}
            }
        },
        methods: {
            getjiant(){
                this.GET("api/agreement/maidian?type=address", function (data) {
                if (data.code == 0) {
                    console.log(data);
                }
                });
            },
            getData(){
                var url = '/api/useraddress/index';
                var _self = this;


                this.GET(url,function (ret) {
                    if(ret.code === 0){
                        _self.address_list = ret.data;
                    }
                })
            }
        },
    }
</script>